import { jwtDecode } from "jwt-decode";
import { setIsLoggedIn, setRole } from "../slices/app";

const isTokenExpired = (decodedToken) => {
  const currentTime = Date.now() / 1000;
  return decodedToken.exp <= currentTime;
};

export const checkToken = (dispatch) => {
  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");

  if (!token && !role) {
    dispatch(setIsLoggedIn(false));
    return;
  }
  try {
    const decodedToken = jwtDecode(token);
    if (isTokenExpired(decodedToken)) {
      localStorage.removeItem("accessToken");
      dispatch(setIsLoggedIn(false));
      dispatch(setRole(""));
    } else {
      dispatch(setIsLoggedIn(true));
      dispatch(setRole(role));
    }
  } catch (error) {
    localStorage.removeItem("accessToken");
    dispatch(setIsLoggedIn(false));
    dispatch(setRole(""));
  }
};
